import React, { FC } from "react";

import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { useContext } from "./hooks/useContext";

export const BasemapSettings: FC = () => {
  const context = useContext();

  return <SimpleDialogFallback context={context} />;
};
